module.exports = __webpack_public_path__ + "img/cb-lr-rr1.0fd57bdc.gif";